import { Text } from '../../components/UI-CHAKRA/Text';
import { ReactComponent as EditIcon } from '../../assets/images/icons/mevo/edit.svg';
import { ReactComponent as DocPaper } from '../../assets/images/icons/ic-doc-paper.svg';
import { Flex } from '../../components/UI-CHAKRA/Flex';

interface LMEBadgeProps {
  onClick(): void;
}

export default function LMEBadge(props: LMEBadgeProps) {
  return (
    <Flex
      cursor={'pointer'}
      p={' 20px'}
      border={'1px solid #CED4DA'}
      borderRadius={'10px'}
      alignItems={'center'}
      justifyContent={'space-between'}
      onClick={props.onClick}
      w={'100%'}
      maxW={'100%'}
      h={'55px'}
    >
      <Flex gap={'10px'} alignItems={'center'}>
        <DocPaper height={'16px'} />
        <Text lineHeight={'11px'} color={'#868E96'} fontWeight={700} fontSize={'10px'}>
          Formulário LME
        </Text>
      </Flex>

      <EditIcon width={15} fill="#868E96" />
    </Flex>
  );
}
